"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c;
    return (react_1.default.createElement("svg", { viewBox: "0 0 24 25", width: scale * 24, height: scale * 25, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M4 4.5h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2z", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "m22 6.5-10 7-10-7", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Icon;
//# sourceMappingURL=Mail.js.map